export default "__VITE_ASSET__1e93728f__"